import { privateFulcrumApi } from './fulcrumApi';
import { QueryClient, QueryFunction } from '@tanstack/react-query';

const defaultQueryFunction: QueryFunction<unknown, ReadonlyArray<unknown>> = ({
  queryKey: [url, data],
}) => {
  return privateFulcrumApi.get(url as string, { params: data }).then(({ data }) => data);
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: defaultQueryFunction,
      refetchOnWindowFocus: false,
    },
  },
});
